import {
    rangeInputElement,
    monthsElement,
    perMonthElement,
    resultMonthsElement,
    resultPerMonthElement,
    resultPerMonthOldElement,
    rangeTrack,
} from "./elements";

export const inputRangeMin = rangeInputElement?.min;
export const inputRangeMax = rangeInputElement?.max;

updateRangeTrack(rangeInputElement?.value);

rangeInputElement?.addEventListener("input", (event) => {
    updateRangeTrack(event.target.value);
});

export function updateRangeTrack(updatingElValue) {
    colorRangeTrack(updatingElValue);
    writeIntoMonths(updatingElValue);
    writeIntoPerMonth(updatingElValue);
}

function colorRangeTrack(rangeInputElementValue) {
    const progress = (rangeInputElementValue / inputRangeMax) * 100;

    if (!rangeTrack || isNaN(progress)) return;

    rangeTrack.style.background = `linear-gradient(to right, #d2fe67 ${progress}%, var(--theme-border-softer) ${progress}%)`;
}

export function writeIntoMonths(inputRangeValue) {
    if (!monthsElement || !resultMonthsElement) return;

    monthsElement.value = inputRangeValue;
    resultMonthsElement.textContent =
        monthsElement[inputRangeValue].textContent;
}

export function writeIntoPerMonth(inputRangeValue) {
    if (!perMonthElement || !resultPerMonthElement) return;

    perMonthElement.value = inputRangeValue;
    resultPerMonthElement.textContent =
        perMonthElement[inputRangeValue].textContent;

    resultPerMonthOldElement.textContent = perMonthElement[inputRangeValue]
        .dataset.old
        ? perMonthElement[inputRangeValue].dataset.old
        : "";
}
